/**
 * Thin wrapper around window.gtag so analytics calls are safe even if the
 * tag didn't load (ad-blockers, missing env var, SSR, etc.).
 *
 * gtag.js is loaded via the standard snippet in /public/index.html.
 * Current loader: AW-17442636375 (Google Ads).
 */
export const GOOGLE_ADS_ID = "AW-17442636375";

const isDev = process.env.NODE_ENV === "development";

function safeGtag(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch (err) {
    if (isDev) console.warn("[track] gtag call failed:", err);
  }
}

export function trackEvent(name, params = {}) {
  safeGtag("event", name, params);
}

/**
 * Fire a Google Ads conversion. If a specific conversion label is available
 * later, pass `label` so send_to becomes `AW-XXXX/LABEL` (required for a
 * named conversion to register in Google Ads). Without a label, this still
 * logs a generic conversion event the user can configure later.
 */
export function trackAdsConversion(label, params = {}) {
  const sendTo = label ? `${GOOGLE_ADS_ID}/${label}` : GOOGLE_ADS_ID;
  trackEvent("conversion", { send_to: sendTo, ...params });
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
